enum DataTrackEvent {
    /** 首页内容点击 */
    CLICK_HOME_CONTENT = "click_home_content",
    /** 单店铺切换订单列表页码 */
    CHANGE_ORDER_LIST_PAGE_SIZE = "change_order_list_page_size",
    /** 跨店铺切换订单列表页码 */
    CHANGE_ALL_SHOP_ORDER_LIST_PAGE_SIZE = "change_all_shop_order_list_page_size",
    /** 单店铺搜索 */
    SEARCH_ONE_SHOP_ORDER_LIST = "search_one_shop_order_list",
    /** 跨店铺搜索 */
    SEARCH_ALL_SHOP_ORDER_LIST = "search_all_shop_order_list",
    /** 切换本地排序 */
    CHANGE_LOCAL_ORDER_SORT = "change_local_order_sort",
    /** 开启自动打印 */
    START_AUTO_PRINT = "start_auto_print",
    /** 浏览自动打印 */
    VIEW_AUTO_PRINT_PAGE = "view_auto_print_page",
    /** 浏览拿货标签 */
    VIEW_PURCHASING_LABEL_PAGE = "view_purchasing_label_page",
    /** 使用拿货标签功能 */
    USE_PURCHASING_LABEL_FEATURE = "use_purchasing_label_feature",
    /** 打印订单 */
    PRINT_ORDERS = "print_orders",
    /** 导入订单 */
    IMPORT_ORDERS = "import_orders",
    /** 设为已有物流信息 */
    SET_HAS_LOGISTICS_INFO = "set_has_LogisticsInfo",
    /** 切换物流预警开关 */
    CHANGE_LOGISTICS_WARN_TOGGLE = "change_logistics_warn_toggle",
    /** 切换到物流预警Tab */
    CHANGE_ORDER_TAB_TO_LOGISTICS_WARN = "change_order_tab_to_logistics_warn",
    /** 拆分单个订单 */
    SPLIT_ORDER = "split_order",
    /** 批量拆分订单 */
    SPLIT_ORDERS = "split_orders",
    /** 导出订单 */
    EXPORT_ORDERS = "export_orders",
    /** 导出备货单 */
    EXPORT_ORDER_PICK_LIST = "export_order_pick_list",
    /** 导出运单号 */
    EXPORT_ORDER_EXPRESS = "export_order_express",
    /** 导出拿货标签 */
    EXPORT_ORDER_PURCHASING_LABEL = "export_order_purchasing_label",
    /** 快递对账 */
    LOGISTICS_AUDIT = "logistics_audit",
    /** 发货统计 */
    SHIPMENT_STATS = "shipment_stats",
    /** 查询操作日志 */
    SEARCH_ORDER_LOG = "search_order_log",
    /** 预发货 */
    PRE_SHIP = "pre_ship",
    /** 点击常用搜索 */
    CLICK_FREQUENT_SEARCH = "click_frequent_search",
    /** 点击常用备注 */
    CLICK_FREQUENT_REMARK = "click_frequent_remark",
    /** 保存快递单模板 */
    SAVE_WAYBILL_TEMPLATE = "save_waybill_template",
    /** 保存发货单模板 */
    SAVE_PICK_LIST_TEMPLATE = "save_pick_list_template",
    /** 保存商品标签模板 */
    SAVE_ORDER_ITEM_LABEL_TEMPLATE = "save_order_item_label_template",
    /** 保存发货人 */
    SAVE_SHIPPING_ADDRESS = "save_shipping_address",
    /** 保存临时打印内容 */
    SAVE_CUSTOM_PRINT_CONTENT = "save_custom_print_content",
    /** 创建（明文/密文）订单 */
    CREATE_PLATFORM_MANUAL_ORDER = "create_platform_manual_order",
    /** 挂起订单 */
    HOLD_ORDER = "hold_order",
    /** 自动合并订单 */
    AUTO_MERGE_ORDER = "auto_merge_order",
    /** 标记订单 */
    MARK_ORDER = "mark_order",

    /** 取消合并订单 */
    CANCEL_MERGE_ORDER = "cancel_merge_order",
    /** 取消拆分订单 */
    CANCEL_SPLIT_ORDER = "cancel_split_order",
    /** 重新同步订单 */
    RESYNC_ORDER = "resync_order",
    /** 复制订单信息 */
    COPY_ORDER_INFO = "copy_order_info",
    /** 锁定订单 */
    LOCK_ORDER = "lock_order",
    /** 解锁订单 */
    UNLOCK_ORDER = "unlock_order",
    /** 加入到黑名单 */
    ADD_TO_BLACK_LIST = "add_to_black_list",
    /** 订单列表搜索项编辑 */
    EDIT_SEARCH_PANE = "edit_search_pane",
    /** 点击异常订单通知 */
    CLICK_ABNORMAL_NOTIFICATION = "click_abnormal_notification",
    /** 修改收货地址 */
    UPDATE_ORDER_CONSIGNEE = "update_order_consignee",
    /** 快速筛选订单 */
    QUICK_SEARCH_ORDER = "quick_search_order",
    /** 重打旧电子面单号 */
    REPRINT_WAYBILL = "reprint_waybill",
    /** 修改打印状态 */
    UPDATE_PRINT_STATUS = "update_print_status",
    /** 修改物流公司 */
    UPDATE_LOGISTICS_COMPANY = "update_Logistics_company",
    /** 更新商品IMEI */
    UPDATE_IMEI = "update_imei",
    /** 退回代发订单 */
    REFUND_DROPSHIPPING_ORDER = "refund_dropshipping_order",
    /** 提交代发订单 */
    SUBMIT_DROPSHIPPING_ORDER = "submit_dropshipping_order",
    /** 打印发货单 */
    PRINT_PICKING_LIST = "print_picking_list",
    /** 打印商品标签 */
    PRINT_ORDER_ITEM_LABEL = "print_order_item_label",
    /** 回收电子面单号 */
    CANCEL_EWAYBILL = "cancel_ewaybill",
    /** 删除电子面单号 */
    DELETE_EWAYBILL = "delete_ewaybill",
    /** 删除库存商品 */
    DELETE_WMS_SKU = "delete_wms_sku",
    /** 恢复库存商品 */
    RESTORE_WMS_SKU = "restore_wms_sku",
    /** 删除异常 */
    DELETE_ABNORMAL_RECORD = "delete_abnormal_record",
    /** 商品销售统计 */
    STATS_PRODUCT_SALES = "stats_product_sales",
    /** 快速查单 */
    ORDER_SEARCH = "order_search",
    /** 生成和打印面单所用的时间 */
    GENERATE_PRINT_EWAYBILL = "generate_print_ewaybill",
    /** 统计发货时间  */
    SHIP = "ship",
    /** 设置网点余额预警  */
    SET_BRANCH_QUANTITY_THRESHOLD = "set_branch_quantity_threshold",
    /** 打开/关闭网点预警 */
    TOGGLE_BRANCH_QUANTITY_THRESHOLD = "toggle_branch_quantity_threshold",
    /** 自定义输入页码 */
    CUSTOM_INPUT_PAGE_SIZE = "custom_input_page_size",
    /** 快速时间选择 */
    QUICK_TIME_SELECT = "quick_time_select",
    /** 打印批次号筛选 */
    PRINT_BATCH_NUMBER_SEARCH = "print_batch_number_search",
    /** 拆分数量打印 */
    SPLIT_BY_QUANTITY_PRINT = "split_by_quantity_print",

    SPLIT_BY_WEIGHT_PRINT = "split_by_weight_print",

    ORDER_ITEM_STATUS_SEARCH = "order_item_status_search",
    /**商品筛选 */
    PRODUCT_FILTER = "product_filter",

    LIKE_OPERATION = "like_operation",

    CHANGE_ORDER_SELECT_STRATEGY = "change_order_select_strategy",
}

export default DataTrackEvent;
